import { css } from "@emotion/react";
import { MEDIA_QUERY_FOR_PC } from "constants/mediaQueryForPc";
import { MEDIA_QUERY_FOR_SP } from "constants/mediaQueryForSp";
import {
  blackBaseButtonStyle,
  whiteBaseButtonStyle,
} from "pages/AccountSettlementHistoryOrderId/styles/commonStyles";

export const blackActionButtonStyle = css`
  ${blackBaseButtonStyle}

  ${MEDIA_QUERY_FOR_PC} {
    width: 328px;
  }

  ${MEDIA_QUERY_FOR_SP} {
    width: 100%;
  }
`;

export const skeletonButtonStyle = css`
  ${blackBaseButtonStyle}
  background: linear-gradient(90deg, #333 25%, #555 50%, #333 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  pointer-events: none;

  @keyframes loading {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }

  ${MEDIA_QUERY_FOR_PC} {
    width: 328px;
  }

  ${MEDIA_QUERY_FOR_SP} {
    width: 100%;
  }
`;

export const whiteActionButtonStyle = css`
  ${whiteBaseButtonStyle}
  ${MEDIA_QUERY_FOR_PC} {
    width: 328px;
  }

  ${MEDIA_QUERY_FOR_SP} {
    width: 100%;
  }
`;
